<template>
    <div class="content" >
        <h1 class="mfo-rules__block-title">Правила предоставления микрокредитов</h1>
        <div class="mfo-rules" v-html="document"></div>
    </div>
</template>
<script>
    import widthMixin from "@/modules/mixins/widthMixin";

    export default {
        name: "GeneralConditions",
        mixins: [widthMixin],
        metaInfo: {
            title: 'Правила предоставления микрокредитов'
        },
        data(){
            return {
                document: ''
            }
        },
        methods: {},
        computed: {},
        beforeCreate(){
            let _this = this;
            this.$http.get('/rulesMfo').then(
                (response) => {
                    if(response.data.code === 0){
                        _this.document = response.data.data;
                    }
                },
                (response) => {},
            );
        }
    };
</script>
<style lang="scss">
    @import "~@/assets/scss/variable";
    .mfo-rules{
        text-align: initial;
        &__block-title{
            font-size: 20px;
            font-family: $RobotoMedium;
            font-weight: normal;
        }
        h3{
            font-weight: normal;
            font-family: $RobotoMedium;
        }
        p{
            font-family: $RobotoRegular;
        }
        strong{
            font-weight: normal;
            font-family: $RobotoMedium;
        }
        table{
            max-width: 960px;
            padding: 0 10px;
            width: 100% !important;
        }
    }
</style>
